import { useState, useEffect } from 'react';
import { Card } from '../ui/Card.jsx';
import { Button } from '../ui/Button.jsx';
import { loadGame, hasSavedGame } from '../../utils/saveManager.js';
import { CONFIG } from '../../config/constants.js';

export function StartScreen({ onNewGame, onLoadGame }) {
  const [hasSave, setHasSave] = useState(false);
  const [saveInfo, setSaveInfo] = useState(null);

  useEffect(() => {
    const savedExists = hasSavedGame();
    setHasSave(savedExists);

    if (savedExists) {
      const saveData = loadGame();
      if (saveData) {
        setSaveInfo({
          day: saveData.day,
          workers: saveData.workers.filter(w => w.status !== 'dead').length,
          lastPlayed: saveData.savedAt
        });
      }
    }
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-200 via-amber-100 to-amber-200 p-4 font-sans flex items-center justify-center">
      <Card title="Dice Settlement" icon="🎲">
        <p className="text-center text-amber-800 mb-6">
          A dice-based settlement survival game. Manage workers, gather resources,
          build structures, and survive {CONFIG.WIN_DAY} days in the wilderness.
        </p>

        {hasSave && saveInfo && (
          <div className="bg-amber-100 border-2 border-amber-600 rounded-lg p-4 mb-4 text-center">
            <p className="text-sm text-amber-900 font-semibold mb-1">Saved Game Found</p>
            <p className="text-xs text-amber-700">
              Day {saveInfo.day} • {saveInfo.workers} workers alive
            </p>
            <p className="text-xs text-amber-600">
              Last played: {new Date(saveInfo.lastPlayed).toLocaleString()}
            </p>
          </div>
        )}

        <div className="space-y-3">
          <Button
            onClick={onNewGame}
            variant="primary"
            className="w-full"
          >
            New Game
          </Button>

          <Button
            onClick={onLoadGame}
            variant="secondary"
            disabled={!hasSave}
            className="w-full"
          >
            {hasSave ? 'Continue Game' : 'No Saved Game'}
          </Button>
        </div>

        <p className="text-xs text-center text-amber-600 mt-4">
          Game auto-saves at the end of each day
        </p>
      </Card>
    </div>
  );
}
